// @ts-nocheck

import { DATA_FIELD_KEYS } from '../../../../../shared/constants';
/* ------------------------------------------------------------------------------------------
 There are three event classifications
 1. core event: INSTALL, OPEN, CLICK, etc
    - core events have a single event name per datasource
 2. standard event: ADD_TO_CART, PURCHASE, VIEW_ITEM, etc
    - one data source has many event names
    - data sources include: eo_commerce_event, eo_content_event, and eo_user_lifecycle_event
 3. custom event
    - custom events are created by the user so are free form
    - data source is eo_custom_event
 -------------------------------------------------------------------------------------------- */
import {
  CLICK_IMPRESSIONS,
  COST_IN_LOCAL_CURRENCY,
  COST as COST_NAME,
  ECPA,
  ECPA_IN_LOCAL_CURRENCY,
  ECPC,
  ECPC_IN_LOCAL_CURRENCY,
  ECPI,
  ECPI_IN_LOCAL_CURRENCY,
  ECPM,
  ECPM_IN_LOCAL_CURRENCY,
  ROAS as ROAS_NAME,
  ROI as ROI_NAME,
} from './datasources';
export const CORE_EVENT_NAMES = {
  INSTALL: 'eo_install',
  PAGEVIEW: 'eo_pageview',
  BRANCH_CTA_VIEW: 'eo_branch_cta_view',
  CLICK: 'eo_click',
  OPEN: 'eo_open',
  REINSTALL: 'eo_reinstall',
  WEB_SESSION_START: 'eo_web_session_start',
  SMS_SENT: 'eo_sms_sent',
  IMPRESSION: 'eo_impression',
  JOURNEYS_DISMISSAL: 'eo_dismissal',
};
// core event names that are applicable in cohorts
export const COHORT_CORE_EVENT_NAMES = ['OPEN', 'PAGEVIEW', 'REINSTALL', 'WEB_SESSION_START'];
export const COST_EVENT_NAMES = {
  [COST_NAME]: COST_NAME,
  [COST_IN_LOCAL_CURRENCY]: COST_IN_LOCAL_CURRENCY,
};

export const PURCHASE = 'PURCHASE';

export const NAMED_COMMERCE_EVENT_NAMES = {
  [PURCHASE]: 'eo_commerce_event',
  ADD_TO_CART: 'eo_commerce_event',
  ADD_TO_WISHLIST: 'eo_commerce_event',
  VIEW_CART: 'eo_commerce_event',
  INITIATE_PURCHASE: 'eo_commerce_event',
  ADD_PAYMENT_INFO: 'eo_commerce_event',
  SPEND_CREDITS: 'eo_commerce_event',
  RESERVE: 'eo_commerce_event',
  CLICK_AD: 'eo_commerce_event',
  VIEW_AD: 'eo_commerce_event',
};
export const COMMERCE_EVENT_NAMES = {
  revenue: 'eo_commerce_event',
  ...NAMED_COMMERCE_EVENT_NAMES,
};
export const COMMERCE_EVENT_NAMES_WITH_LOCAL_CURRENCY = {
  ...COMMERCE_EVENT_NAMES,
  revenue_in_local_currency: 'eo_commerce_event',
};
export const COMMERCE_EVENT_NAMES_BLOCKED = {
  revenue_blocked: 'eo_commerce_event_blocked',
  PURCHASE_BLOCKED: 'eo_commerce_event_blocked',
  ADD_TO_CART_BLOCKED: 'eo_commerce_event_blocked',
  ADD_TO_WISHLIST_BLOCKED: 'eo_commerce_event_blocked',
  VIEW_CART_BLOCKED: 'eo_commerce_event_blocked',
  INITIATE_PURCHASE_BLOCKED: 'eo_commerce_event_blocked',
  ADD_PAYMENT_INFO_BLOCKED: 'eo_commerce_event_blocked',
  SPEND_CREDITS_BLOCKED: 'eo_commerce_event_blocked',
  RESERVE_BLOCKED: 'eo_commerce_event_blocked',
  CLICK_AD_BLOCKED: 'eo_commerce_event_blocked',
  VIEW_AD_BLOCKED: 'eo_commerce_event_blocked',
};
export const CONTENT_EVENT_NAMES = {
  SEARCH: 'eo_content_event',
  VIEW_ITEM: 'eo_content_event',
  VIEW_ITEMS: 'eo_content_event',
  RATE: 'eo_content_event',
  SHARE: 'eo_content_event',
  INITIATE_STREAM: 'eo_content_event',
  COMPLETE_STREAM: 'eo_content_event',
};
export const CONTENT_EVENT_NAMES_BLOCKED = {
  SEARCH_BLOCKED: 'eo_content_event_blocked',
  VIEW_ITEM_BLOCKED: 'eo_content_event_blocked',
  VIEW_ITEMS_BLOCKED: 'eo_content_event_blocked',
  RATE_BLOCKED: 'eo_content_event_blocked',
  SHARE_BLOCKED: 'eo_content_event_blocked',
  INITIATE_STREAM_BLOCKED: 'eo_content_event',
  COMPLETE_STREAM_BLOCKED: 'eo_content_event',
};
export const USER_LIFECYCLE_EVENT_NAMES = {
  COMPLETE_REGISTRATION: 'eo_user_lifecycle_event',
  COMPLETE_TUTORIAL: 'eo_user_lifecycle_event',
  ACHIEVE_LEVEL: 'eo_user_lifecycle_event',
  UNLOCK_ACHIEVEMENT: 'eo_user_lifecycle_event',
  INVITE: 'eo_user_lifecycle_event',
  LOGIN: 'eo_user_lifecycle_event',
  SUBSCRIBE: 'eo_user_lifecycle_event',
  START_TRIAL: 'eo_user_lifecycle_event',
  OPT_IN: 'eo_user_lifecycle_event',
  OPT_OUT: 'eo_user_lifecycle_event',
  UNINSTALL: 'eo_user_lifecycle_event',
};
export const USER_LIFECYCLE_EVENT_NAMES_BLOCKED = {
  COMPLETE_REGISTRATION_BLOCKED: 'eo_user_lifecycle_event_blocked',
  COMPLETE_TUTORIAL_BLOCKED: 'eo_user_lifecycle_event_blocked',
  ACHIEVE_LEVEL_BLOCKED: 'eo_user_lifecycle_event_blocked',
  UNLOCK_ACHIEVEMENT_BLOCKED: 'eo_user_lifecycle_event_blocked',
  INVITE_BLOCKED: 'eo_user_lifecycle_event_blocked',
  LOGIN_BLOCKED: 'eo_user_lifecycle_event_blocked',
  SUBSCRIBE_BLOCKED: 'eo_user_lifecycle_event_blocked',
  START_TRIAL_BLOCKED: 'eo_user_lifecycle_event_blocked',
  OPT_IN_BLOCKED: 'eo_user_lifecycle_event_blocked',
  OPT_OUT_BLOCKED: 'eo_user_lifecycle_event_blocked',
  UNINSTALL_BLOCKED: 'eo_user_lifecycle_event_blocked',
};
export const CALCULATED_COST_IN_LOCAL_CURRENCY_EVENT_NAMES = {
  [ECPA_IN_LOCAL_CURRENCY]: ECPA_IN_LOCAL_CURRENCY,
  [ECPC_IN_LOCAL_CURRENCY]: ECPC_IN_LOCAL_CURRENCY,
  [ECPI_IN_LOCAL_CURRENCY]: ECPI_IN_LOCAL_CURRENCY,
  [ECPM_IN_LOCAL_CURRENCY]: ECPM_IN_LOCAL_CURRENCY,
};
export const CALCULATED_COST_EVENT_NAMES = {
  [ECPI]: ECPI,
  [ECPC]: ECPC,
  [ECPM]: ECPM,
  [ECPA]: ECPA,
  [CLICK_IMPRESSIONS]: CLICK_IMPRESSIONS,
};
export const CALCULATED_REVENUE_EVENT_NAMES = {
  [ROI_NAME]: ROI_NAME,
  [ROAS_NAME]: ROAS_NAME,
};
export const CURRENCY_EVENT_NAMES = {
  ARPPU: 'ARPPU',
  LTV: 'LTV',
  ARPU: 'ARPU',
};
export const CALCULATED_EVENT_NAMES = { ...CALCULATED_COST_EVENT_NAMES, ...CALCULATED_REVENUE_EVENT_NAMES };
export const CALCULATED_EVENT_NAMES_WITH_LOCAL_CURRENCY = {
  ...CALCULATED_EVENT_NAMES,
  ...CALCULATED_COST_IN_LOCAL_CURRENCY_EVENT_NAMES,
};
export const CALCULATED_OTT_EVENT_NAMES = {};
export const ADS_EVENTS_HUMAN_READABLE: Record<string, any> = {
  ARPPU: 'Average Revenue per Paying User (ARPPU)',
  GROSS_PROFIT: 'Gross Profit',
  ROI: 'Return on Investment (ROI)',
  ROAS: 'Return on Ad Spend (ROAS)',
  eCPI: 'Effective Cost per Install (eCPI)',
  eCPA: 'Effective Cost per Purchase (eCPA)',
  Retention: 'Retention',
  ARPU: 'Average Revenue per User (ARPU)',
  LTV: 'Lifetime Value (LTV)',
};
export const REVENUE_IN_LOCAL_CURRENCY_HUMAN_READABLE: string = 'Revenue (Local Currency)';
export const LOCAL_CURRENCY_EVENTS_HUMAN_READABLE: string[] = [
  'Revenue (Local Currency)',
  'Cost (Local Currency)',
  'eCPC (Local Currency)',
  'eCPA (Local Currency)',
  'eCPI (Local Currency)',
  'eCPM (Local Currency)',
];
export const LOCAL_CURRENCY_EVENTS_TO_HUMAN_READABLE = {
  revenue_in_local_currency: 'Revenue (Local Currency)',
  cost_in_app_local_currency: 'Cost (Local Currency)',
  calculated_eCPA_in_local_currency: 'eCPA (Local Currency)',
  calculated_eCPC_in_local_currency: 'eCPC (Local Currency)',
  calculated_eCPI_in_local_currency: 'eCPI (Local Currency)',
  calculated_eCPM_in_local_currency: 'eCPM (Local Currency)',
  eCPA_in_local_currency: 'eCPA (Local Currency)',
  eCPC_in_local_currency: 'eCPC (Local Currency)',
  eCPI_in_local_currency: 'eCPI (Local Currency)',
  eCPM_in_local_currency: 'eCPM (Local Currency)',
};

export const CALCULATION_TOPICS_TO_HUMAN_READABLE = {
  [DATA_FIELD_KEYS.ECPI]: 'eCPI',
  [DATA_FIELD_KEYS.ECPC]: 'eCPC',
  [DATA_FIELD_KEYS.ECPM]: 'eCPM',
  [DATA_FIELD_KEYS.ECPA]: 'eCPA',
  [DATA_FIELD_KEYS.ECPI_IN_LOCAL_CURRENCY]: 'eCPI (Local Currency)',
  [DATA_FIELD_KEYS.ECPC_IN_LOCAL_CURRENCY]: 'eCPC (Local Currency)',
  [DATA_FIELD_KEYS.ECPM_IN_LOCAL_CURRENCY]: 'eCPM (Local Currency)',
  [DATA_FIELD_KEYS.ECPA_IN_LOCAL_CURRENCY]: 'eCPA (Local Currency)',
  [DATA_FIELD_KEYS.ROI]: 'ROI',
  [DATA_FIELD_KEYS.ROAS]: 'ROAS',
  [DATA_FIELD_KEYS.AVERAGE_REVENUE]: 'average revenue per PURCHASE',
};

export const REVENUE_MEASURE_EVENT_NAMES = [
  'revenue',
  CURRENCY_EVENT_NAMES.ARPU,
  CURRENCY_EVENT_NAMES.ARPPU,
  CURRENCY_EVENT_NAMES.LTV,
  'GROSS_PROFIT',
];
export const REVENUE_IN_LOCAL_CURRENCY_MEASURE_EVENT_NAMES = ['revenue_in_local_currency'];
export const REVENUE_RELATED_EVENT_NAMES = [
  ...REVENUE_MEASURE_EVENT_NAMES,
  ...REVENUE_IN_LOCAL_CURRENCY_MEASURE_EVENT_NAMES,
  'ROI',
];
export const BLOCKED_EVENTS_HUMAN_READABLE = {
  revenue_blocked: 'blocked revenue',
  PURCHASE_BLOCKED: 'blocked purchase',
  ADD_TO_CART_BLOCKED: 'blocked add to cart',
  ADD_TO_WISHLIST_BLOCKED: 'blocked add to wishlist',
  VIEW_CART_BLOCKED: 'blocked view cart',
  INITIATE_PURCHASE_BLOCKED: 'blocked initiate purchase',
  ADD_PAYMENT_INFO_BLOCKED: 'blocked add payment info',
  SPEND_CREDITS_BLOCKED: 'blocked spend credits',
  RESERVE_BLOCKED: 'blocked reserve',
  CLICK_AD_BLOCKED: 'blocked click ad',
  VIEW_AD_BLOCKED: 'blocked view ad',
  SEARCH_BLOCKED: 'blocked search',
  VIEW_ITEM_BLOCKED: 'blocked view item',
  VIEW_ITEMS_BLOCKED: 'blocked view items',
  RATE_BLOCKED: 'blocked rate',
  SHARE_BLOCKED: 'blocked share',
  INITIATE_STREAM_BLOCKED: 'blocked initiate stream',
  COMPLETE_STREAM_BLOCKED: 'blocked complete stream',
  COMPLETE_REGISTRATION_BLOCKED: 'blocked complete registration',
  COMPLETE_TUTORIAL_BLOCKED: 'blocked complete tutorial',
  ACHIEVE_LEVEL_BLOCKED: 'blocked achieve level',
  UNLOCK_ACHIEVEMENT_BLOCKED: 'blocked unlock achievement',
  INVITE_BLOCKED: 'blocked invite',
  LOGIN_BLOCKED: 'blocked login',
  SUBSCRIBE_BLOCKED: 'blocked subscribe',
  START_TRIAL_BLOCKED: 'blocked start trial',
  OPT_IN_BLOCKED: 'blocked opt in',
  OPT_OUT_BLOCKED: 'blocked opt out',
  UNINSTALL_BLOCKED: 'blocked uninstall',
};

/* ------------
 Aggregations
-------------- */
export const ALL_EVENT_NAMES = {
  ...CORE_EVENT_NAMES,
  ...COMMERCE_EVENT_NAMES,
  ...CONTENT_EVENT_NAMES,
  ...USER_LIFECYCLE_EVENT_NAMES,
  [COST_NAME]: COST_NAME,
};

export const STANDARD_EVENT_NAMES = {
  ...COMMERCE_EVENT_NAMES,
  ...CONTENT_EVENT_NAMES,
  ...USER_LIFECYCLE_EVENT_NAMES,
};
export const ALL_EVENT_NAMES_WITH_LOCAL_CURRENCY = {
  ...CORE_EVENT_NAMES,
  ...COMMERCE_EVENT_NAMES_WITH_LOCAL_CURRENCY,
  ...CONTENT_EVENT_NAMES,
  ...USER_LIFECYCLE_EVENT_NAMES,
  ...COST_EVENT_NAMES,
};
export const STANDARD_EVENT_NAMES_WITH_LOCAL_CURRENCY = {
  ...CONTENT_EVENT_NAMES,
  ...COMMERCE_EVENT_NAMES_WITH_LOCAL_CURRENCY,
  ...USER_LIFECYCLE_EVENT_NAMES,
};
export const STANDARD_EVENT_NAMES_BLOCKED = {
  ...COMMERCE_EVENT_NAMES_BLOCKED,
  ...CONTENT_EVENT_NAMES_BLOCKED,
  ...USER_LIFECYCLE_EVENT_NAMES_BLOCKED,
};
export const ALL_NAMED_EVENT_NAMES = {
  ...CORE_EVENT_NAMES,
  ...NAMED_COMMERCE_EVENT_NAMES,
  ...CONTENT_EVENT_NAMES,
  ...USER_LIFECYCLE_EVENT_NAMES,
};
